export const options = [
  { label: "За рейтингом", sortBy: "rating", order: "desc" },
  { label: "За назвою А-Я", sortBy: "title", order: "asc" },
  {
    label: "За назвою Я-А",
    sortBy: "title",
    order: "desc",
  },
  { label: "Від найдешевших", sortBy: "price", order: "asc" },
  {
    label: "Від найдорожчих",
    sortBy: "price",
    order: "desc",
  },
  { label: "За роком випуску", sortBy: "year", order: "asc" },
];
